import { ReactElement, cloneElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';

import { Box, SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material';
import {
    Menu as MenuIcon,
    ChevronLeft as ChevronLeftIcon,
    LinkedIn as LinkedInIcon
} from '@mui/icons-material';

import {
    FilledButton, IconButton,
    InitiaPublicTopAppBar,
    TextButton
} from '@initia-digital/component-library';
import { useOptionalProp } from '@initia-digital/ts-utils';

import { CONFIG } from '../config/const';
import { useStore } from '../store';

const {
    DEFAULT_PAGE_CONFIG: PAGE_CONFIG
} = CONFIG;

export interface IPageStyles {
    bgColor?: string
}

export interface IPageProps {
    children: ReactElement
}


export const BasicPublicAppBarPage = ({ children, bgColor }: IPageProps & IPageStyles) => {
    // --------------------------------------------------------------
    // ZUSTAND GLOBAL STORE
    const {
        isSideDrawerOpen,
        setIsSideDrawerOpen
    } = useStore(useShallow(state => ({
        isSideDrawerOpen: state.isSideDrawerOpen,
        setIsSideDrawerOpen: state.setIsSideDrawerOpen
    })));

    const setBgColor = useOptionalProp(bgColor, 'white');

    // ROUTER
    const navigate = useNavigate();

    const theme = useTheme();
    const isSmallerThanMd = useMediaQuery(theme.breakpoints.down('md'));


    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <InitiaPublicTopAppBar
                appName={PAGE_CONFIG.appName}
                appVersion={PAGE_CONFIG.appVersion}
                avatarButtonList={[
                    {
                        href: 'https://www.linkedin.com/company/initia-ltd',
                        icon: <LinkedInIcon />,
                        tooltipLabel: `Initia's LinkedIn`,
                        bgColor: '#0072b1',
                        color: "white",
                        ariaLabel: `LinkedIn`
                    }
                ]}
                showHomeImage={false}
                homeImageHandleClick={() => navigate('/')}
                menuIconButton={
                    <Box
                        border={"1px solid transparent"}
                        borderRadius="5px"
                    >
                        <IconButton

                            color="black"
                            size='large'
                            onClick={() => setIsSideDrawerOpen(true)}
                        >
                            <MenuIcon sx={{ height: '30px', width: '30px' }} />
                        </IconButton>
                    </Box>
                }
            />
            <SwipeableDrawer
                anchor={'left'}
                open={isSideDrawerOpen}
                onOpen={() => setIsSideDrawerOpen(true)}
                onClose={() => setIsSideDrawerOpen(false)}
            >
                <Box
                    width={'250px'}
                    p="20px"
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        my="10px"
                    >
                        <TextButton
                            onClick={() => setIsSideDrawerOpen(false)}
                            startIcon={<ChevronLeftIcon />}
                        >
                            Close
                        </TextButton>
                    </Box>
                    <FilledButton
                        backgroundColor={'#0072b1'}
                        color={'white'}
                        disabled={false}
                        size={isSmallerThanMd ? "small" : "medium"}
                        onClick={() => window.open(`https://www.linkedin.com/company/initia-ltd`, '_blank')}
                        startIcon={<LinkedInIcon />}
                    >
                        LinkedIn
                    </FilledButton>
                </Box>
            </SwipeableDrawer>
            <Box flexGrow={1} display="flex" flexDirection="column" paddingTop="30px" paddingBottom="50px" bgcolor={setBgColor} sx={{ transition: 'background-color 0.5s ease' }}>
            {
                cloneElement(children)
            }
            </Box >
        </Box >
    );
} 